<template>
    <b-container fluid class="mt--7">
        <b-card :title="title">
            <b-card-body>
                <b-table :items="items" :fields="fields">
                    <template #cell(control)="{ index, item }">
                        <b-button
                            v-if="index == items.length - 1"
                            variant="link"
                            @click="addNote(item)"
                            >Add
                        </b-button>
                        <b-button
                            v-else
                            variant="link"
                            @click="deleteNote(index)"
                            >Remove
                        </b-button>
                    </template>

                    <template #cell(name)="{ index, item, value }">
                        <b-form-input
                            v-if="index == items.length - 1"
                            :id="`input-name${index}`"
                            placeholder="name"
                            v-model="item.name"
                            type="text"
                        ></b-form-input>

                        <span v-else>{{ value }}</span>
                    </template>

                    <template #cell(value)="{ index, item, value }">
                        <b-form-input
                            v-if="index == items.length - 1"
                            :id="`input-value${index}`"
                            placeholder="Value"
                            v-model="item.value"
                            type="text"
                        ></b-form-input>

                        <span v-else>{{ value }}</span>
                    </template>
                </b-table>
            </b-card-body>
        </b-card>
    </b-container>
</template>

<script>
import popupMixins from '@/mixins/popupMixins'
import permissionsMixins from '@/mixins/permissionsMixins'

export default {
    name: 'companyNotes',
    mixins: [popupMixins, permissionsMixins],
    data: () => ({
        componentName:'Company Notes',
        title: 'Company Notes',
        fields: ['name', 'value', { key: 'control', label: '' }],
        model: {
            notes: [],
        },
        updating: false,
    }),

    computed: {
        notes() {
            const resp = this.$store.getters['company/companyNotes']
            const notes = (resp && resp.notes) || []
            console.log('computed notes', notes)
            return notes
        },
        settingKeys() {
            return this.$store.state.company.settingKeys.companyNoteKey
        },
        items() {
            return [...this.model.notes, { name: '', value: '' }]
        },
    },

    watch: {
        notes: {
            handler: function (val) {
                console.log('watch notes', val)
                this.updateModel(val)
            },
            deep: true,
        },
    },
    async mounted() {
        const { settingKeys } = this
        console.log('settingKeys', settingKeys)
        await this.$store.dispatch('company/fetchConfiguration', settingKeys)
        this.$nextTick(() => {
            this.updateModel(this.notes)
        })
    },

    methods: {
        updateModel(notes) {
            console.log('notes-------------', notes)
            // const { notes } = companyNotes
            this.$set(this.model, 'notes', notes)
        },
        async updateSettings(type,name) {
            try {
                this.updating = true
                const text_value = JSON.stringify(this.model)
                const bool_value = false

                this.$store.dispatch('company/updateConfiguration', {
                    key: this.settingKeys,
                    text_value,
                    bool_value,
                })

                this.genericToast(this.componentName,type,'success', `"${name}" successfully ${type.toLowerCase()}`)
                //this.doToast('Success!', 'Settings Updated', 'success')

            } catch (error) {
                this.doToast('Error!', error.message, 'danger')
            } finally {
                this.updating = false
            }
        },

        addNote: function ({ name, value }) {
            const noDuplicate=(value)=>{return value===true?'Error':'Duplicate'}
            try {
                if (!name || !value) {
                    const action=noDuplicate(true)
                    throw {name: action, message:'Please complete all fields'}  
                    
                }

                if (this.model.notes.some(x => x.name === name)) {
                    const action=noDuplicate(false)
                   
                    throw {name: action, message:`"${name}" is already in use. Please select a different name`}
                    
                }

                this.model.notes.push({
                    name,
                    value,
                })
                this.$nextTick(() => {
                    this.updateSettings('Created', name)
                })
            } catch (error) {
                console.log(error)
                this.genericToast(`${this.componentName}`, error.name, 'danger', error.message)
            }
        },
        deleteNote: function (index) {
            console.log('>> ', index)
            let currentIndex=  this.model.notes[index].name
            this.model.notes.splice(index, 1)
            this.$nextTick(() => {
                this.updateSettings('Deleted',currentIndex)
            })
        },
    },
}
</script>
